import {
	type inferParserType,
	parseAsArrayOf,
	parseAsString,
	useQueryStates,
} from 'nuqs'

import { parseAsTime } from '~/lib/nuqs-parse-as-time'

export type BookingOptions = inferParserType<typeof parsers>

const parsers = {
	day: parseAsArrayOf(parseAsString),
	end: parseAsTime,
	start: parseAsTime,
}

export const useBookingOptions = () => {
	return useQueryStates(parsers)
}
